import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuList, MenuItem, Link } from '@material-ui/core';
import { HOME, ALIGNMENTMAPS, ADMIN, REPORTS, WHATS_NEW_ROADMAP, MAILS } from '../../config/app-url';
import { adminTabPermission } from '../../config/rolePermission';
import { HomeIcon, RoadmapIcon } from '../../config/svg/HeaderActionSvg';
import { SendEmailIcon } from '../../config/svg/CommonSvg';

export default function UserNavigation(props) {
	const { currentRoute, updateRoute, location, resetOkr } = props;
	const { t } = useTranslation();

	useEffect(() => {
		const path = location && location.pathname ? location.pathname : '';
		resetOkr();
		updateRoute(path);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	let employeePermissions = [];
	if (
		props.getPermissionStatus === 'success' &&
		props.getPermissionResult &&
		props.getPermissionResult.employeePermissions
	) {
		employeePermissions = props.getPermissionResult.employeePermissions;
	}
	return (
		<MenuList>
			<MenuItem
				id='impersonate'
				className={`home ${currentRoute === HOME ? 'active' : ''}`}
				onClick={(e) => {
					props.switchUser(e, 'user', HOME);
				}}
			>
				<Link title={t('Dashboard')}>
					<span className='nav-icon'>
						<HomeIcon />
					</span>
					<span className='nav-label'>{t('Dashboard')}</span>
				</Link>
			</MenuItem>
			{/* Old "What's New" (id='whats-new', route WHATS_NEW) is intentionally hidden from the
			    sidebar in favor of the new WHATS_NEW_ROADMAP item below. Its route/component are
			    left untouched and still work if navigated to directly. */}
			<MenuItem
				id='whats-new-roadmap'
				className={`${currentRoute === WHATS_NEW_ROADMAP ? 'active' : ''}`}
				onClick={(e) => {
					props.switchUser(e, 'user', WHATS_NEW_ROADMAP);
				}}
			>
				<Link title={t('whatsNew')}>
					<span className='nav-icon'>
						<RoadmapIcon />
					</span>
					<span className='nav-label'>{t('whatsNew')}</span>
				</Link>
			</MenuItem>
			<MenuItem
				id='email'
				className={`${currentRoute === MAILS ? 'active' : ''}`}
				onClick={(e) => {
					props.switchUser(e, 'user', MAILS);
				}}
			>
				<Link title={t('emails')}>
					<span className='nav-icon'>
						<SendEmailIcon />
					</span>
					<span className='nav-label'>{t('emails')}</span>
				</Link>
			</MenuItem>
		</MenuList>
		// <MenuList>
		// 	<MenuItem
		// 		id='okrs'
		// 		className={`home ${currentRoute === HOME ? 'active' : ''}`}
		// 		onClick={(e) => {
		// 			props.switchUser(e, 'user', HOME);
		// 		}}
		// 	>
		// 		<Link>{t('okrsLabel')}</Link>
		// 	</MenuItem>
		// 	<MenuItem
		// 		id='alignmentMaps'
		// 		className={currentRoute === ALIGNMENTMAPS ? 'active' : ''}
		// 		onClick={(e) => {
		// 			props.switchUser(e, 'user', ALIGNMENTMAPS);
		// 		}}
		// 	>
		// 		<Link>{t('alignmentMaps')}</Link>
		// 	</MenuItem>
		// 	{/* <MenuItem
		// 		id='insight'
		// 		className={currentRoute === INSIGHT ? 'active' : ''}
		// 		onClick={(e) => {
		// 			props.switchUser(e, 'user', INSIGHT);
		// 		}}
		// 	>
		// 		<Link>{t('insights')}</Link>
		// 	</MenuItem> */}
		// 	<MenuItem
		// 		id='reports'
		// 		className={currentRoute === REPORTS ? 'active' : ''}
		// 		onClick={(e) => {
		// 			props.switchUser(e, 'user', REPORTS);
		// 		}}
		// 	>
		// 		<Link>{t('reports')}</Link>
		// 	</MenuItem>

		// 	{adminTabPermission(employeePermissions) ? (
		// 		<MenuItem
		// 			id='admin'
		// 			className={currentRoute === ADMIN ? 'active' : ''}
		// 			onClick={(e) => {
		// 				props.switchUser(e, 'admin', ADMIN);
		// 			}}
		// 		>
		// 			<Link>{t('admin')}</Link>
		// 		</MenuItem>
		// 	) : (
		// 		<></>
		// 	)}
		// </MenuList>
	);
}
